import React, {Component} from 'react';
import * as d3 from 'd3';
import CommandAPIs from '../../../../APIs/CommandAPIs'
import actions from '../../../../../src/store/actions'
import { nodeName } from 'jquery';
import moment from 'moment/moment';

let assets = {
    frame: require('../TorkView/assets/dialframe.png'),
    batterycharge: require('../TorkView/assets/batterycharge.png'),
    batterystroke: require('../TorkView/assets/batterystroke.png'),
    batterychargestroke: require('../TorkView/assets/batterychargestroke.png'),
    motortemp: require('../TorkView/assets/motortemp.png'),
    ecutemp: require('../TorkView/assets/ecutemp.png'),
    high: require('../TorkView/assets/high.png'),
    hornactive: require('../TorkView/assets/hornactive.png'),
    horninactive: require('../TorkView/assets/horninactive.png'),
    keyactive: require('../TorkView/assets/keyactive.png'),
    keyinactive: require('../TorkView/assets/keyinactive.png'),
    killswitch: require('../TorkView/assets/killswitch.png'),
    rpm: require('../TorkView/assets/rpm.png'),
    throttleinactive: require('../TorkView/assets/throttleinactive.png'),
    throttleactive: require('../TorkView/assets/throttleactive.png'),
    backlight0: require('../TorkView/assets/backlight0.png'),
    backlight1: require('../TorkView/assets/backlight1.png'),
    indicator0: require('../TorkView/assets/indicator0.png'),
    indicator1: require('../TorkView/assets/indicator1.png'),
    lightbeam: require('../TorkView/assets/headlight.png'),
    cycle: require('../TorkView/assets/count-01.png'),
    celltemp: require('./assets/battery_horiz.png'),
    medkit: require('./assets/medkit.png'),
    notcharging: require('../TorkView/assets/not_charging.png'),
    normalcharging: require('../TorkView/assets/charging.png'),
    fastcharging: require('../TorkView/assets/fast.png'),
}

let statKeys = [
    'indicatorL',
    'indicatorR',
    'tailLamp',
    'fuel',
    'ignitionstatus',
    'rpm',
    'torque',
    'batteryVoltage',
    'ctrltemp',
    'motortemp',
    'mincelltemp',
    'maxcelltemp',
    'highBeam',
    'pass',
    'drl',
    'horn',
    'odometer',
    'btv',
    'mincellvolt',
    'maxcellvolt',
    'batcurrent',
    'speed',
    'throttle',
    'headlight',
    'killSwitch',
    'torkChargingStatus',
    'soh',
]

class EtrioView extends Component {
    state = {
        stats: {},
        simulating: false,
        allowchg: null,
        allowdischg: null,
        vehicleno: null,
        oldBtn: true,
        cmdInfos: [],
        busy: true,
        online: true,
        devStateKey: [
            {key:1, name: "Active"},
            {key:2, name: "Inactive"},
            {key:3, name: "Sleep"},
            {key:4, name: "Deep Sleep"},
        ]
            
    }
    constructor(props){
        super(props)
        window.callCmdBtnApi = () => {
            window.onMarkerClicked = false
            let vehicle = props.vehicle()
            this.setState({vehicleno:vehicle.vehicleno, busy: true,cmdInfos: []},() => {})
            let body = {
                vehicleno: vehicle.vehicleno
            }
            CommandAPIs.getBatteryCancmdInfos(body).then((resp) => {
                setTimeout(() => {
                    for(let idx in resp) {
                        if(resp[idx].status_key !== null){
                            let statskey = resp[idx].status_key
                            let cmds = resp[idx].cmd
                            let statusMap = cmds[0].status_map

                            if(statskey in this.props.currentState.can){
                                let status = this.props.currentState.can[statskey]
                                resp[idx].status = statusMap.status[status]
                            }else {
                                resp[idx].status = ""
                            }
                            this.setState({oldBtn:false},() =>{})
                        }
                    }
                    this.setState({cmdInfos: resp, busy:false},() => {})
                },2000)
            }).catch(() => {
                this.setState({busy: false, oldBtn: true})
            })
        }
    }
    componentDidMount() {
        this.initDial()
        // let vehicle =this.props.vehicle()
        // this.chargeControl = vehicle.vehiclemeta.charge_control
        // this.dischargeControl = vehicle.vehiclemeta.discharge_control
    }
    componentWillUnmount() {
        clearInterval(this.simulate);
    }
    componentDidUpdate(props, state) {
        if(state.stats.rpm != this.state.stats.rpm) {
            this.redrawDial()
        }
    }
    simulateDial() {
        let simulate = (otherState = {}) => {
            this.setState({
                ...otherState,
                stats: {
                    ...this.state.stats,
                    indicatorL: Math.round(Math.random() * 1),
                    indicatorR: Math.round(Math.random() * 1),
                    tailLamp: Math.round(Math.random() * 1),
                    fuel: Math.round(Math.random() * 100),
                    ignitionstatus: Math.round(Math.random() * 1),
                    rpm: Math.round(Math.random() * 8000),
                    torque: Math.round(Math.random() * 80),
                    ctrltemp: Math.round(Math.random() * 60),
                    motortemp: Math.round(Math.random() * 140),
                    mincelltemp: Math.round(Math.random() * 140),
                    maxcelltemp: Math.round(Math.random() * 140),
                    highBeam: Math.round(Math.random() * 1),
                    pass: Math.round(Math.random() * 1),
                    drl: Math.round(Math.random() * 1),
                    horn: Math.round(Math.random() * 1),
                    odometer: (parseInt(this.state.stats.odometer) || 0) + Math.round(Math.random() * 10),
                    btv: (Math.random() * 15).toFixed(1),
                    batteryVoltage: (Math.random() * 15).toFixed(1),
                    mincellvolt: (Math.random() * 15).toFixed(1),
                    maxcellvolt: (Math.random() * 15).toFixed(1),
                    batcurrent: (Math.random() * 2).toFixed(1),
                    speed: Math.round(Math.random() * 120),
                    throttle: Math.round(Math.random() * 1),
                    headlight: Math.round(Math.random() * 1),
                    killSwitch: Math.round(Math.random() * 1),
                    torkChargingStatus: Math.round(Math.random() * 1),
                    soh: Math.round(Math.random() * 100),
                    tiv: Math.round(Math.random() * 100),
                    chc: Math.round(Math.random() * 100),
                    bmstmp: Math.round(Math.random() * 100),
                }
            })
        }
        simulate({simulating: true})
        this.simulate = setInterval(simulate, 2000)
    }
    onSimulate = () => {
        if(this.state.simulating) {
            clearInterval(this.simulate);
            let stats = Object.assign(...statKeys.map(s => ({[s]:0})))
            console.log("state data for ev:",stats)
            this.setState({simulating:false,stats:{...this.state.stats,...stats}})
        } else {
            this.simulateDial();
        }
    }
    redrawDial = () => {
        let twoPi = Math.PI * 2;
        let startAngle = .65;
        let maxAngle = .7;
        function arcTween(newAngle) {
            return function(d) {
                var interpolate = d3.interpolate(d.endAngle, newAngle);
                return function(t) {
                    d.endAngle = interpolate(t);
                    return arc(d);
                };
            };
        }
        let arc = d3.arc()
            .innerRadius(this.radius - this.border)
            .outerRadius(this.radius)
            .cornerRadius(this.border)
            .startAngle(twoPi * startAngle);

        let progress = (this.state.stats.rpm || 0) / 8000;
        d3.select('#clipx path')
            .transition()
            .duration(1000)
            .attrTween('d', arcTween(twoPi * (maxAngle * progress + startAngle)))
            
    }
    initDial = () => {
        let width = 150, height = 150;
        let margin = {top:10,right:10,bottom:10,left:10};
        let radius = this.radius = width / 2;
        let border = this.border = 8;

        let svg = d3.select('.tv-fr-dial svg');
        width = width - margin.left - margin.right;
        height = height - margin.top - margin.bottom;
        svg.attr('width', width + margin.left + margin.right);
        svg.attr('height', height + margin.top + margin.bottom);
        
        let twoPi = Math.PI * 2;
        let endAngle = 1.35;
        let startAngle = .65;

        let arc = d3.arc()
            .innerRadius(radius - border)
            .outerRadius(radius)
            .cornerRadius(border)
            .startAngle(twoPi * startAngle);

        svg.append('defs')
            .append('clipPath')
            .attr('id', 'clipx')
            .append('path')
            .datum({endAngle: twoPi * endAngle})
            .attr('d', arc.endAngle(twoPi * endAngle))

        let g = svg.append('g')
            .attr('transform', 'translate(' + radius + ',' + radius + ')');

        arc.endAngle(twoPi * endAngle)

        g.append('path')
            .attr('fill', '#686868')
            .attr('d', arc);
        
        g.append('path')
            .attr('fill', 'url(#gradx)')
            .attr('d', arc)
            .style('clip-path', 'url(#clipx)');

        g.append('path')
            .attr('fill', '#ccc')
            .attr('d', arc.innerRadius(radius - border - 3).outerRadius(radius - border - 2));


        let data = [10, 20, 30, 40, 50, 60, 70, 80]
        let axis = d3.scaleLinear()
            .range([0, 252])
            .domain(d3.extent(data, d => d))
        radius = radius - 22
        g.append('g')
            .attr('transform', 'translate(0,4)')
            .selectAll('text')
            .data(data)
            .enter()
            .append('text')
            .text(d => d)
            .attr('transform', d => {
                let ratio = axis(d);
                let angle = 144 + ratio;
                angle = angle / 360
                let x = Math.cos(twoPi * angle) * radius;
                let y = Math.sin(twoPi * angle) * radius;
                return 'translate(' + x + ',' + y + ')';
            })

        g.append('g')
            .attr('transform', 'translate(0,0)')
            .selectAll('text')
            .data(data)
            .enter()
            .append('line')
            .each(function(d) {
                let ratio = axis(d);
                let angle = 144 + ratio;
                angle = angle / 360
                let xCoord = radius => Math.cos(twoPi * angle) * radius
                let yCoord = radius => Math.sin(twoPi * angle) * radius
                d3.select(this)
                    .attr('x1', xCoord(radius + 12))
                    .attr('x2', xCoord(radius + 8))
                    .attr('y1', yCoord(radius + 12))
                    .attr('y2', yCoord(radius + 8))
            })
    }
    updateView = () => {
        if(!this.state.simulating) {
            setTimeout(()=>{
                let incomingV = this.props.vehicle().stats;
                let stats = {...this.state.stats,...incomingV};
                // console.log(stats)
                this.setState({stats}, this.forceUpdate);
            }, 100);
        }
    }
    renderRpmColor() {
        let colors = ['#3dedf0', '#41fca2', '#ec7d4f', '#ff4200'];
        let progress = (this.state.stats.rpm || 0) / 8000;
        return {color:colors[Math.round((colors.length - 1) * progress)]};
    }
    checkGroup = () => {
        let groupInfo = null;
        if(window.selectedVehicles && window.selectedVehicles && window.selectedVehicles[0] && window.selectedVehicles[0].data && window.selectedVehicles[0].data.groupinfo && window.selectedVehicles[0].data.groupinfo[0]){
            groupInfo = window.selectedVehicles[0].data.groupinfo[0]
        }
        // checking jpm -gid 2600
        if(groupInfo){
            if(groupInfo[0] === 2600) return true
            
        }
    }

    zyppMobilize = (type) => {
        let vehicle = this.props.vehicle()
        let body = {
            vehicleno: vehicle.vehicleno,
            type: type,
        }
        CommandAPIs.standardMobilize(body).then((resp) => {
            this.props.data.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: 'Command Sent Successfully',
                    content: "Command Successful. Status will be updated in 60 secs",
                    createAt:Date.now(),
                    autoClose: 8000,
                    // createAt: dmsg.pnt,
                }
            })
        }).catch((resp) => {
            this.props.data.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: 'Command Failed',
                    content: resp.response.data.msg || "Command Failed",
                    createAt:Date.now(),
                    autoClose: 8000,
                    // createAt: dmsg.pnt,
                }
            })
        })
    }

    zyppImmobilize = (type) => {
        let vehicle = this.props.vehicle()
        let body = {
            vehicleno: vehicle.vehicleno,
            type: type,
        }
        CommandAPIs.standardImmobilize(body).then((resp) => {
            this.props.data.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: 'Command Sent Successfully',
                    content:"Command Successful. Status will be updated in 60 secs",
                    autoClose: 8000,
                    createAt:Date.now()
                    // createAt: dmsg.pnt,
                }
            })
        }).catch((resp) => {
            this.props.data.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: 'Command Failed',
                    content: resp.response.data.msg || "Command Failed",
                    createAt:Date.now(),
                    // createAt: dmsg.pnt,
                    autoClose: 8000,
                }
            })
        })
    }

    isBilitiCheck = () => {
        let vehicle = this.props.vehicle()
        if(vehicle && vehicle.vehicleModel && vehicle.vehicleModel.oem && vehicle.vehicleModel.model && vehicle.vehicleModel.variant) {
            if(vehicle.vehicleModel.oem === "Biliti" && vehicle.vehicleModel.model === "52V" && vehicle.vehicleModel.variant === "Default" ) {
                return true
            }else {
                return false
            }
        }else {
            return false
        }
    }

    buttonControl = (action) =>{
        // if(action === "allowchg"){
        //     document.getElementsByClassName("tv-btrbc-allow")[0].style.disabled = "none"
        //     document.getElementsByClassName("tv-btrbc-allow")[0].style.backgroundColor = "grey"
        //     setTimeout(()=>{
        //         console.log(this.state.stats.allowchg)
        //            document.getElementsByClassName("tv-btrbc-allow")[0].style.pointerEvents = "auto"
        //            document.getElementsByClassName("tv-btrbc-allow")[0].style.backgroundColor = "#1abc9c"
        //     },5000)
        // }
        // if(action === "cutoffchg"){
        //     document.getElementsByClassName("tv-btrbc-cutoff")[0].style.pointerEvents = "none"
        //     document.getElementsByClassName("tv-btrbc-cutoff")[0].style.backgroundColor = "grey"
        //     setTimeout(()=>{
        //         console.log(this.state.stats.allowchg)
        //            document.getElementsByClassName("tv-btrbc-cutoff")[0].style.pointerEvents = "auto"
        //            document.getElementsByClassName("tv-btrbc-cutoff")[0].style.backgroundColor = "#e8685b"
        //     },5000)
        // }
        // if(action === "allowdischg"){
        //     document.getElementsByClassName("tv-btrbd-allow")[0].style.pointerEvents = "none"
        //     document.getElementsByClassName("tv-btrbd-allow")[0].style.backgroundColor = "grey"
        //     setTimeout(()=>{
        //            document.getElementsByClassName("tv-btrbd-allow")[0].style.pointerEvents = "auto"
        //            document.getElementsByClassName("tv-btrbd-allow")[0].style.backgroundColor = "#1abc9c"
        //     },5000)
        // }
        // if(action === "cutoffdischg"){
        //     document.getElementsByClassName("tv-btrbd-cutoff")[0].style.pointerEvents = "none"
        //     document.getElementsByClassName("tv-btrbd-cutoff")[0].style.backgroundColor = "grey"
        //     setTimeout(()=>{
        //            document.getElementsByClassName("tv-btrbd-cutoff")[0].style.pointerEvents = "auto"
        //            document.getElementsByClassName("tv-btrbd-cutoff")[0].style.backgroundColor = "#e8685b"
        //     },5000)
        // }

        let isBiliti = this.isBilitiCheck()
        let vehicle = this.props.vehicle()
        let body = {
            vehicleid:vehicle.vehicleid,
            modelid: vehicle.vehiclemeta.modelid,
            // action:action
        }
        if(isBiliti){
            if(action === "allowchg") {
                body.action = "uart_allowchg"
            }else if(action === "cutoffchg"){
                body.action = "uart_cutoffchg"
            }else if(action === "allowdischg"){
                body.action = "uart_allowdischg"
            }else if(action === "cutoffdischg"){
                body.action = "uart_cutoffdischg"
            }
            
        }else {
            body.action = action
        }

        // Add validity parameter for bgauss OEM (72 hours in milliseconds)
        const oem = vehicle?.vehicleModel?.oem || vehicle?.vehiclemeta?.oem;
        if (oem === "BGauss") {
            const validity = 72 * 60 * 60 * 1000; // 72 hours in milliseconds
            body.validity = validity;
        }

        CommandAPIs.chargeDischargeControl(body)
        .then((resp) => {
            this.props.data.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: 'Command Sent Successfully',
                    content: ' "Command Successful. Status will be updated in 60 secs"',
                    createAt:Date.now(),
                    autoClose: 8000,
                    // createAt: dmsg.pnt,
                }
            })
        })
        .catch((resp) =>{
            this.props.data.dispatch({
                type: actions.ADD_INTOAST,
                data: {
                    name: 'Command Failed',
                    content: resp.response.data.msg || "Command Failed",
                    createAt:Date.now(),
                    // createAt: dmsg.pnt,
                    autoClose: 8000,
                }
            })
        })
    }
    getClassName = (btn,cmd) => {
        let color = ""
        let classname = "new-btn"
        let status = this.getCmdStatus(cmd)
        color = btn && btn.status_map && btn.status_map.color && btn.status_map.color[status] ? btn.status_map.color[status] : null
        if(color !== null){
            classname = classname+"-"+color

        }else classname = classname+"-blue"
        return classname
    }
    getCmdStatus =(cmd) => {
        if(cmd.status_key in this.props.currentState.can) {
            let statusValue = this.props.currentState.can[cmd.status_key]
            let status = cmd && cmd.cmd && cmd.cmd[0] && cmd.cmd[0].status_map && cmd.cmd[0].status_map.status 
            && cmd.cmd[0].status_map.status[statusValue] ? cmd.cmd[0].status_map.status[statusValue] : ""
            return status
        }else {
            return ""
        }
    }
    createBtn = (cmd,index) => {
        return (
            <div className='new-btns'key={index} >
                <span className='new-status'>Status : {this.getCmdStatus(cmd)}</span>
                <div className='btn-container'>
                {
                    cmd.cmd.map((btn,index) => {
                        return (
                            <span key={index} className={this.getClassName(btn,cmd)} onClick={() => {this.buttonControl(btn.action)}}>{btn.name}</span>
                        )
                    })
                }
            </div>
            </div>
        )
    }
    checkCantitme = () => {
        if(this.props.currentState.can && this.props.currentState.can.cpts) {
            let currentTime = Date.now()
            if(this.props.currentState.can.cpts >= currentTime - 60000) {
                return true
            }else false
        }
        return false
    }

    getDevicestate = () => {
        let devState = this.props?.currentState?.vehicle?.GPS?.dst || null
        let state = ""
        if(devState !== null){
            state = this.state.devStateKey.map((state) => {
                if(state.key === devState) return state.name
            })

        }

        return state

    }
    render() {
        const {
            ctrltemp,
            bmstmp,
            mincellvolt,
            maxcellvolt,
            tiv,
            chc,
            mincelltemp,
            batteryTemp,
        } = this.state.stats;
        return (
            <div className="TorkView etrio">
                <div className="tv-fr-btns">
                    <button onClick={this.onSimulate} style={{display:'none'}}><i className={'fa fa-' + (this.state.simulating ? 'pause' : 'play') + '-circle'}></i></button>
                </div>
                <div className="tv-top-fr">
                    <div className="tv-tfl-lt">
                        {this.state.stats.headlight == 1 && <img src={assets.lightbeam} />}
                    </div>
                    <div className="tv-tfr-dia">
                        <div className="tv-fr-dial">
                            <svg>
                                <defs>
                                    <linearGradient id="gradx" x1="0%" x2="100%" y1="0" y2="0">
                                        <stop offset="0%" stopColor="#3dedf0"></stop>
                                        <stop offset="30%" stopColor="#41fca2"></stop>
                                        <stop offset="80%" stopColor="#ec7d4f"></stop>
                                        <stop offset="100%" stopColor="#ff4200"></stop>
                                    </linearGradient>
                                </defs>
                            </svg>
                        </div>
                        <div className="tv-tfr-diac">
                            <div className="tv-tdc-top">
                                <div>{this.state.stats.speed || 0}</div>
                                <div>KMPH</div>
                            </div>
                            <div className="tv-tdc-btm">
                                {tiv ?
                                <div className="tv-tdc-btx">{tiv || 0}<span>V</span></div>
                                :
                                <div className="tv-tdc-btx">{mincellvolt || 0}<span>V</span> / {maxcellvolt || 0}<span>V</span></div>
                                }
                            </div>
                        </div>
                        <div className="tv-tfr-diat">
                            <div className="tv-tfd-lft">
                                <img src={assets.killswitch} style={{filter:'grayscale(' + (this.state.stats.killSwitch ? 0 : 1) + ')'}} />
                            </div>
                            <div className="tv-tfd-mid">
                                <div className={(this.state.stats.highBeam || 0) == 1 ? 'ltup' : 'ltgr'}><img src={assets.high} /></div>
                                <div className={"tv-tfd-mid-chr"}>{this.state.stats.chargeType === 2 ?<img src={assets.fastcharging}/> :this.state.stats.chargeType === 1 ? <img src={assets.normalcharging}/> : <img src={assets.notcharging}/>}</div>
                                <div >{this.state.stats.ridemode  ===  null  ? "D/M" : this.state.stats.ridemode}</div>
                            </div>
                        </div>
                        <div className="tv-tfr-dial">
                            <div className="tv-tfd-lft">
                                <span className="tv-tf-name">Voltage</span>
                                <div className="tv-tf-t">{this.state.stats && this.state.stats.batteryVoltage !== undefined ? this.state.stats.batteryVoltage.toFixed(2): this.checkGroup() && this.state.stats.carbattery !== undefined ?   this.state.stats.carbattery.toFixed(2) : 0}<span> V</span></div>
                            </div>
                            <div className={'tv-tfd-mid' + ((this.state.stats.fuel || 0) < 15 ? ' bt-lw' : '')}>
                                <span className="tv-tf-name-soc">SoC</span>
                                <div className={'tv-tfm-b'}>
                                    <div className="tv-tfm-bb" style={{height:(this.state.stats.fuel || 0) + '%'}}></div>
                                    <img src={(this.state.stats.fuel || 0) < 15 ? assets.batterychargestroke : assets.batterystroke} />
                                    {this.state.stats.torkChargingStatus == 1 && <img src={assets.batterycharge} />}
                                </div>
                                <div>{this.state.stats.fuel || 0}%</div>
                            </div>
                            <div className="tv-tfd-rgt">
                                <span className="tv-tf-name">Current</span>
                                <div className="tv-tf-t">{this.state.stats.batcurrent || 0}<span> A</span></div>
                            </div>
                        </div>
                        <div className="tv-tfr-diar">
                            <div className="tv-tdr g top">
                                <div className="tv-tf-im"><img src={assets.motortemp} /></div>
                                <div className="tv-tf-tx">{this.state.stats.motortemp || 0}<span>&deg;C</span></div>
                                <span className="tv-tf-name">Motor Temp</span>
                            </div>
                            <div className="tv-tdr g mid">
                                <div className="tv-tf-im"><img src={assets.celltemp} /></div>
                                { batteryTemp ? <div className="tv-tf-tx">{ batteryTemp }<span>&deg;C</span></div>
                                :<div className="tv-tf-tx">{mincelltemp || 0}<span>&deg;C</span>  / {this.state.stats.maxcelltemp || 0}<span>&deg;C</span></div>}
                                {/* <div className="tv-tf-tx">{mincelltemp || batteryTemp || 0}<span>&deg;C</span> / {this.state.stats.maxcelltemp || 0}<span>&deg;C</span></div> */}
                                <span className="tv-tf-name">{batteryTemp ?"Battery Temp": "Cell Temp"}</span>

                            </div>
                            <div className="tv-tdr g btm">
                                <div className="tv-tf-im"><img src={assets.ecutemp} /></div>
                                <div className="tv-tf-tx">{ctrltemp || bmstmp || 0}<span>&deg;C</span></div>
                                <span className="tv-tf-name">BMS/Controller</span>

                            </div>
                            <div className="tv-tdr dri">
                                <div className="tv-tf-im"><img src={assets.cycle} /></div>
                                <div className="tv-tf-tx">{chc || 0}</div>
                                <span className="tv-tf-name">Charge cycles(CAN)</span>

                            </div>
                        </div>
                        <div className="tv-tfr-diab">
                            <div className="tv-tdb-lft">
                                <img src={assets.rpm} />
                                <div>
                                    <div className="tv-tdb-t">KWH</div>
                                    <div className="tv-tdb-b">{this.state.stats.kwh || 0}</div>
                                </div>
                            </div>
                            <div className="tv-tdb-rgt">
                                <img src={assets.rpm} />
                                <div>
                                    <div className="tv-tdb-t">RPM</div>
                                    <div className="tv-tdb-b" style={this.renderRpmColor()}>{this.state.stats.rpm || 0}</div>
                                </div>
                            </div>
                            <div className="tv-tdb-lftt w">
                                {/* <img src={this.state.stats.horn ? assets.hornactive :  assets.horninactive} /> */}
                                <span className="tv-tf-name">SoH</span>
                                <img src={assets.medkit} /> <span>{this.state.stats.soh || 0}%</span>
                            </div>
                            <div className="tv-tdb-rgtt">
                                <img src={this.state.stats.ignitionstatus ? assets.keyactive :  assets.keyinactive} />
                            </div>
                        </div>
                        <div className="tv-tfr-ind">
                            <div className={'tv-tfi-bl rgt' + (this.state.stats.tailLamp ? ' ltup' : '')}>
                                <img src={assets.backlight0} />
                                <img src={assets.backlight1} className="brgt" />
                            </div>
                            <div className={'tv-tfi-bl lft' + (this.state.stats.tailLamp ? ' ltup' : '')}>
                                <img src={assets.backlight0} />
                                <img src={assets.backlight1} className="brgt" />
                            </div>
                            <div className={'tv-tfi-il rgt' + (this.state.stats.indicatorR ? ' ltup' : '')}>
                                <img src={assets.indicator0} />
                                <img src={assets.indicator1} className="brgt" />
                            </div>
                            <div className={'tv-tfi-il lft' + (this.state.stats.indicatorL ? ' ltup' : '')}>
                                <img src={assets.indicator0} />
                                <img src={assets.indicator1} className="brgt" />
                            </div>
                        </div>
                        <div className="tv-tfr-odo">
                            <div className="tv-tfr-odl">
                                {(() => {
                                    let digits = (parseInt(this.state.stats.odometer) || 0).toString().padStart(6, '0').split('');
                                    return digits.map((d, i) => <div key={i}> {d}</div>);
                                })()}
                            </div>
                        </div>
                    </div>
                    <img src={assets.frame} />
                </div>
                
                {this.state.busy ? <div className='loading'></div> : this.state.oldBtn ? <div className='tv-bottom-fr'>
                    {window.selectedVehicle && window.selectedVehicle.vehiclemeta.charge_control&&
                         window.selectedVehicle.vehiclemeta.charge_control  === "ON"  || window.selectedVehicle && window.selectedVehicle.vehiclemeta.discharge_control&&
                         window.selectedVehicle.vehiclemeta.discharge_control  === "ON"  ? 
                         <div className='can-state-section'>
                             <div className='can-data-section'>
                            <div className='can-data-title'>Last CAN Time :</div>
                            <div className={this.checkCantitme() ? "can-data-online" : "can-data-offline"}>
                                <span className='can-time'>{this.props.currentState.can.cpts ? moment(this.props.currentState.can.cpts).format("DD-MMM-YYYY HH:mm") : "NA"}</span> 
                                <span className={this.checkCantitme() ? "online" : "offline"}></span>
                            </div>
                        </div>
                            <div className='device-state'>
                            <div className='dev-title'>Device State :  </div> 
                            <div>{this.getDevicestate()}</div>
                         </div>
                         </div>
                        :null}
                   {window.selectedVehicle && window.selectedVehicle.vehiclemeta.charge_control&&
                         window.selectedVehicle.vehiclemeta.charge_control  === "ON"  || window.selectedVehicle && window.selectedVehicle.vehiclemeta.discharge_control&&
                         window.selectedVehicle.vehiclemeta.discharge_control  === "ON"  ? <div className='tv-bfr-line'></div> : null} 
                    
                    {window.selectedVehicle && window.selectedVehicle.vehicleModel.variant === 'Zypp_Trontek' &&
                    <div className='tv-btr-zypp'>
                        <div className="tv-btrz-title">Charge Discharge Control</div>
                        <div className='tv-btrz-btns'>
                            <div className='tv-btrz-btns1'><span onClick={() => this.zyppMobilize('chargendischarge')}>Enable</span></div>
                            <div className='tv-btrz-btns2'><span onClick={ () => this.zyppImmobilize('chargendischarge')}>Disable</span></div>
                        </div>
                    </div> }
                    <div className='tv-btr-btns'>
                        {window.selectedVehicle && window.selectedVehicle.vehiclemeta.charge_control&&
                         window.selectedVehicle.vehiclemeta.charge_control  === "ON" ? <div className='tv-btrb-charging'>
                            <div className='tv-btrbc-heading'>Charging Control {
                                 this.state.stats.allowchg === 1? <span > : <span className='status-green'>Allow</span> </span> :
                                 this.state.stats.allowchg === 0 ? <span > : <span className='status-red'>Cut-off</span> </span>  : ":"}</div>
                            <div className='tv-btrbc-btns'>
                                <div className={ this.state.stats.allowchg === 1 &&  window.selectedVehicle.vehiclemeta.chargeValidation === true ? 'tv-btrbc-allow-active' :'tv-btrbc-allow'} ref="charge_allow"  onClick={() => this.buttonControl('allowchg')}>
                                    <span >Allow Charging</span>
                                </div>
                                <div className= { this.state.stats.allowchg === 0 &&  window.selectedVehicle.vehiclemeta.chargeValidation === true ? 'tv-btrbc-cutoff-active' : 'tv-btrbc-cutoff'} onClick={() => this.buttonControl('cutoffchg')}>
                                    <span>Cut-off Charging</span>
                                </div>
                            </div>
                        </div> :null}

                        {window.selectedVehicle && window.selectedVehicle.vehiclemeta.discharge_control&&
                         window.selectedVehicle.vehiclemeta.discharge_control  === "ON" ? <div className='tv-btrb-discharging'>
                            <div className='tv-btrbd-heading'>Discharging Control{
                                this.state.stats.allowdischg === 1? <span > : <span className='status-green'>Allow</span> </span>  :
                                this.state.stats.allowdischg === 0 ? <span > : <span className='status-red'>Cut-off</span> </span> : ":"}</div>
                            <div className='tv-btrbd-btns'>
                                <div className={this.state.stats.allowdischg === 1 &&  window.selectedVehicle.vehiclemeta.chargeValidation === true  ?'tv-btrbd-allow-active' : 'tv-btrbd-allow' } onClick={() => this.buttonControl('allowdischg')}>
                                    <span>Allow Discharging</span>
                                </div>
                                <div className= { this.state.stats.allowdischg === 0 &&  window.selectedVehicle.vehiclemeta.chargeValidation === true  ? 'tv-btrbd-cutoff-active' : 'tv-btrbd-cutoff'} onClick={() => this.buttonControl('cutoffdischg')}>
                                    <span>Cut-off Discharging</span>
                                </div>
                            </div>
                        </div> : null }
                    </div>
                    
                </div>:<div className='tv-bottom-new'>
                    <div className='lines'>
                        <div className='can-data-section'>
                            <div className='can-data-title'>Last CAN Time :</div>
                            <div className={this.checkCantitme() ? "can-data-online" : "can-data-offline"}>
                                <span className='can-time'>{this.props.currentState.can.cpts ? moment(this.props.currentState.can.cpts).format("DD-MMM-YYYY HH:mm") : "NA"}</span> 
                                <span className={this.checkCantitme() ? "online" : "offline"}></span>
                            </div>
                            {/* {console.log(this.props,this.props.currentState)} */}
                            <div className='device-state'> Device State: {this.getDevicestate()} </div>
                        </div>
                        <div className='top-line'></div>
                    </div>
                    {this.state.cmdInfos.map((cmd,index) => {
                        if(cmd.status_key !== null) return this.createBtn(cmd,index)
                    })}
                </div>}
            </div>
        )
    }
}

export default EtrioView;
